import styled from 'styled-components'
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";

export const HeaderDescription = styled.h2`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 1rem;
    letter-spacing: 0.15px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 30px */
`

export const TitleContainer = styled.div<{ hasDocument?: boolean }>`
    padding: 1rem;
    border-radius: var(--3, 24px);
    background: var(--background-success, #F1F7FF);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${props => props.hasDocument ? '7rem' : '4rem'};
    
    @media only screen and (max-width: 600px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
        gap: 1.5rem;
    }
`

export const ConfirmedJobBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
    gap: 0.625rem;
    @media only screen and (max-width: 600px) {
        max-width: 100%;
    }
`
export const RightContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
    gap: 0.625rem;
    @media only screen and (max-width: 600px) {
        max-width: 100%;
    }
`

export const Link = styled.a`
    color: var(--info-main, #0288D1);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 166%;
    letter-spacing: 0.4px;`

export const CheckMark = styled(CheckCircleOutlined)`
    width: 1.5rem;
    margin: 0 1rem;
`

export const SafetyGuidelines = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

export const Subtitle = styled.div`
    font-size: var(--typography-body2-size);
    line-height: 1.3;
    color: #000;
    font-weight: 400;
    opacity: 60%;
`

export const ValueBox = styled.h5`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-feature-settings: 'clig' off, 'liga' off;
    
    font-size: var(--typography-h5-size);
    font-style: normal;
    font-weight: 600;
    line-height: 133.4%; /* 32.016px */
    margin: unset;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    @media only screen and (max-width: 600px) {
        font-size: var(--font-size-mid);
    }
`

export const ShiftBoxRateDescription = styled.div`
    display: flex;
    font-size: 0.9rem;
    line-height: 1.3;
    font-weight: 500;
    color: var(--text-primary);
    margin-bottom: 0.5rem;
`

export const Value = styled.h4`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: var(--typography-h5-size);
    font-style: normal;
    font-weight: 600;
    line-height: 123.5%;
    letter-spacing: 0.25px;
    margin: unset;
    //width: 100%;
    @media only screen and (max-width: 600px) {
        font-size: var(--typography-h6-size);
    }
`

export const DateTimeDescription = styled.div`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: var(--input-helper-size);
    line-height: 166%; /* 19.92px */
    letter-spacing: 0.4px;
    font-style: normal;
    font-weight: 400;
`

export const DescriptionContainer = styled.div`
    display: flex;
    padding: var(--3, 24px);
    flex-direction: column;
    gap: 27px;
    border-radius: var(--3, 24px);
    background: var(--background-info, #F7F7F7);
    margin: 1rem 0;

    @media only screen and (max-width: 400px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
    }
`

export const LinkButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    text-decoration: underline;
`

export const CancelOffer = styled(StyledButton)`
    max-width: 10rem;
    max-height: 2.5rem;
    flex-direction: row !important;
`

export const CancelOfferBox = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 0 0 1rem;
`

export const CompleteShiftBox = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0 0;
`
